<template>
  <div id="app">
    <router-view :key="$router.currentRoute.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // 1rem = 100px
    //this.setFontSize(document, window);
  },
  methods: {
    setFontSize(doc, win) {
      var docEl = doc.documentElement;
      var resizeEvt =
        "orientationchange" in window ? "orientationchange" : "resize";
      var reCaculate = function () {
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        docEl.style.fontSize = 100 * (clientWidth / 1920) + "px";
      };
      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, reCaculate, false);
      doc.addEventListener("DOMContentLoaded", reCaculate, false);
    },
  },
};
</script>

<style>

body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  /* font-family: Source Han Sans CN, Source Han Sans CN-Bold; */
  /* font-family: Helvetica, Helvetica-Regular; */
  height: 100%;
  font-family: SourceHanSansCNRegular;
  font-size: 16px;
  color: #333;
}
.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.line2 {
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
#app {
  height: 100%;
}
i, span {
  display: inline-block;
  vertical-align: middle;
}
html {
  box-sizing: border-box;
  height: 100%;
}
.html {
  i, span {
    display: initial;
    vertical-align: initial;
  }
}
* {
  padding: 0;
  margin: 0;
}
*,
*:before,
*:after {
  box-sizing: border-box;
}

a:focus,
a:active {
  outline: none;
}
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
/* ::-webkit-scrollbar{width:6px;height:6px;

    background-color: #00000040;

}

::-webkit-scrollbar-thumb{background-color:#0082ce;border-radius:10px;}

::-webkit-scrollbar-track{background-color:transparent; } */

</style>



// WEBPACK FOOTER //
// src/App.vue